import { Pipe, PipeTransform } from "@angular/core";
import { Alarm } from "../models/alarm";
import { AlarmService } from "../services/alarm.service";

@Pipe({
    name: 'highestAlarmInGroupPipe'
})

export class HighestAlarmInGroupPipe implements PipeTransform{

    //alarm array is the same for all the groups... no use passing it as a param 
    constructor(private alarmService: AlarmService){}
    
    transform(countGroupId: number ) : Alarm{

        var alarms:Alarm[] = this.alarmService.alarms;

        if(!alarms)
            return;

        var alarmsInThisGroup:Alarm[] = [];

        alarms.forEach(alarm => {
            if(alarm.alarm_group_id == countGroupId)
                alarmsInThisGroup.push(alarm)
        });

        console.log("alarms in this group", alarmsInThisGroup, countGroupId)

        if(!alarmsInThisGroup)
            return;

            //get highest alarm level
        var highestAlarmLevel:number = alarmsInThisGroup[0].alarm_level
        alarmsInThisGroup.forEach(alarm => {
            if(alarm.alarm_level > highestAlarmLevel)
                highestAlarmLevel = alarm.alarm_level
        })

        var numberOfAlarmsInThisGroup:number = alarmsInThisGroup.length
        i = 0;
        alarmsInThisGroup.forEach(alarm => {
            if(alarmsInThisGroup[i].alarm_level < highestAlarmLevel){
                alarmsInThisGroup.splice(i,1)
            }
            i +=1
        })

       //only alarms with the highest alarm level now left in alarms in this group

        var latestAlarm: number = +alarmsInThisGroup[0].alarm_created
        var numberOfAlarmsLeftInThisGroup = alarmsInThisGroup.length
        
        alarmsInThisGroup.forEach(alarm => {
            if(+alarm.alarm_created > highestAlarmLevel)
                latestAlarm = +alarm.alarm_created
        })

        for(var i = 0; i < numberOfAlarmsLeftInThisGroup; i++) {
            if(+alarmsInThisGroup[i].alarm_created < latestAlarm){
                alarmsInThisGroup.splice(i,1)
            }
        }

        return alarmsInThisGroup[0] //just pick the first
    }
}


@Pipe({
    name: 'highestAlarmInGroupPipeReturnAlarmLevel'
})

export class HighestAlarmInGroupPipeReturnAlarmLevel implements PipeTransform{
    
    

    //alarm array is the same for all the groups... no use passing it as a param 
    constructor(private alarmService: AlarmService){}
    
    transform(countGroupId: number ) : number{

        var alarms:Alarm[] = this.alarmService.alarms;

        if(!alarms)
            return;

        var alarmsInThisGroup:Alarm[] = [];

        alarms.forEach(alarm => {
            if(alarm.alarm_group_id == countGroupId)
                alarmsInThisGroup.push(alarm)
        });

        console.log("alarms in this group", alarmsInThisGroup, countGroupId)

        if(!alarmsInThisGroup)
            return;

            //get highest alarm level
        var highestAlarmLevel:number = alarmsInThisGroup[0].alarm_level
        alarmsInThisGroup.forEach(alarm => {
            if(alarm.alarm_level > highestAlarmLevel)
                highestAlarmLevel = alarm.alarm_level
        })

        var numberOfAlarmsInThisGroup:number = alarmsInThisGroup.length
        i = 0;
        alarmsInThisGroup.forEach(alarm => {
            if(alarmsInThisGroup[i].alarm_level < highestAlarmLevel){
                alarmsInThisGroup.splice(i,1)
            }
            i +=1
        })

       //only alarms with the highest alarm level now left in alarms in this group

        var latestAlarm: number = +alarmsInThisGroup[0].alarm_created
        var numberOfAlarmsLeftInThisGroup = alarmsInThisGroup.length
        
        alarmsInThisGroup.forEach(alarm => {
            if(+alarm.alarm_created > highestAlarmLevel)
                latestAlarm = +alarm.alarm_created
        })

        for(var i = 0; i < numberOfAlarmsLeftInThisGroup; i++) {
            if(+alarmsInThisGroup[i].alarm_created < latestAlarm){
                alarmsInThisGroup.splice(i,1)
            }
        }

        return alarmsInThisGroup[0].alarm_level //just pick the first
    }
}
